export default __webpack_public_path__ + "static/media/DIREITO PDF.981b5c91.pdf";